import { createSlice } from '@reduxjs/toolkit';

export const recycleBag = createSlice({
  name: 'recycleBag',
  initialState: {
    data: {},
  },

  reducers: {
    setRecycleBag: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setRecycleBag } = recycleBag.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getRecycleBag = (state) => {
  return state.recycleBag.data;
};

export default recycleBag.reducer;
